import React from 'react'

const Volunteer = () => {
    return (
        <div className='pick'>
            <h2 className='h2Title'>Volunteer Work</h2>
            <h3 className='VolTitle'>
                <p>
                    Church of Jesus Christ of Latter Day Saints as a missionary from October 2012 to October 2014
                </p>
                <p>
                 Chambers Prairie Elementary School as a Special ed and 1st grade Teachers Assistant from October 2010 to June 2011
                </p>
                <p>
                   Wichita Kansas Segwick County Zoo from January 2010 to May 2010
                </p>
                <p>
                 Maize South Elementary School as a 3rd Grade Teachers Assistant
                </p>
                <p>
                    Did a lot of service projects between 2007 to 2011 including helping others' Eagle Scout projects
                </p>
            </h3>
        </div>
    )
}

export default Volunteer